import { APIError } from '@/api'

const INVALID_INVITE_TOKEN_CODE = 'invalid_invite_token'

export const isInvalidInviteTokenError = (error: unknown): error is APIError<string> => {
  if (!(error instanceof APIError) || error.status !== 406 || typeof error.body !== 'string') return false

  try {
    const body: unknown = JSON.parse(error.body)

    return (
      typeof body === 'object' &&
      body !== null &&
      !Array.isArray(body) &&
      'code' in body &&
      body.code === INVALID_INVITE_TOKEN_CODE
    )
  } catch {
    return false
  }
}
